'use strict';
Object.defineProperty(exports, '__esModule', {
    value: true
});
var _context = require('./context');
Object.keys(_context).forEach(function(key) {
    if (key === 'default' || key === '__esModule') return;
    if (key in exports && exports[key] === _context[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _context[key];
        }
    });
});
